import { CheckCircleRounded, ErrorRounded, WarningRounded } from "@mui/icons-material";

export const alertStyles = {
  error: {
    outlined: {
      bg: "components-alert-error-background",
      border: "border-error-main",
    },
    standard: {
      bg: "components-alert-error-background",
      border: "border-transparent",
      text: "components-alert-error",
    },
    icon: <ErrorRounded className="!fill-error-main" />,
  },
  warning: {
    outlined: {
      bg: "components-alert-warning-background",
      border: "border-warning-main",
    },
    standard: {
      bg: "components-alert-warning-background",
      border: "border-transparent",
      text: "components-alert-warning-color",
    },
    icon: <WarningRounded className="!fill-text-warning-main" />,
  },
  success: {
    outlined: {
      bg: "components-alert-success-background",
      border: "border-success-main",
    },
    standard: {
      bg: "components-alert-success-background",
      border: "border-transparent",
      text: "components-alert-success-color",
    },
    icon: <CheckCircleRounded className="!fill-success-main" />,
  },
};
